module.exports = "/_next/static/images/avatar3-61396db8be8674e539f7760d34adf98f.jpg";